import { File } from '../file';
import { InternChatText } from '../intern/chat-text';
import { ContentButton } from './button';

/**
 * Model definition for Linda
 */
export interface ContentLinda {
  __component: 'content.linda';
  id: string;
  media: File;
  answer: ContentButton;
  texts: InternChatText[];
  overline?: string;
  headline?: string;
  avatar?: File;
}
export function isContentLinda(obj: { __component?: string }): obj is ContentLinda {
  return obj.__component === 'content.linda';
}
